import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import BorderElement from './components/BorderElement'
import * as DarkBlue from './components/DarkBlueBorders'
import * as Gray from './components/GrayBorders'
import FooterTop from './components/FooterBorder'

const RootContainer = styled.div`
	position: relative;
	width: 100%;
	
	svg {
		fill: ${props => props.underColor};
	}
	
	${props => props.type === 'darkBlue' && `
		background: ${props.theme.colors.secondary};
		padding: 155px 0 102px;
		color: white;
	`}
	
	${props => props.type === 'darkBlueBottom' && `
		background: ${props.theme.colors.secondary};
		padding: 155px 0 102px 0;
		color: white;
	`}
	
	
	${props => props.type === 'gray' && `
		background: ${props.theme.colors.grayBack};
		padding: 108px 0 64px;
	`}
	
	${props => props.type === 'grayTop' && `
		background: ${props.theme.colors.grayBack};
		padding: 108px 0 0;
	`}
	
	${props => props.type === 'footer' && `
		padding-top: 116px;
		background: ${props.theme.colors.grayBack};
		padding: 108px 0 64px;
		background: ${props.theme.colors.secondary};
		color: white;
	`}
`

const WavyBackground = ({className, type, children, underColor}) => <RootContainer
	underColor={underColor}
	type={type}
	className={`${className} ${['darkBlue', 'darkBlueBottom', 'footer'].includes(type) ? 'darkBack' : ''}`}>
	{type === 'darkBlue' && <>
		<BorderElement borderPosition='top' shapeElement={DarkBlue.Top}/>
		<BorderElement borderPosition='bottom' shapeElement={DarkBlue.Bottom}/>
	</>}

	{type === 'darkBlueBottom' && <>
		<BorderElement borderPosition='bottom' shapeElement={DarkBlue.Bottom}/>
	</>}
	{type === 'gray' && <>
		<BorderElement borderPosition='top' shapeElement={Gray.Top}/>
		<BorderElement borderPosition='bottom' shapeElement={Gray.Bottom}/>
	</>}

	{type === 'grayTop' && <>
		<BorderElement borderPosition='top' shapeElement={Gray.Top}/>
	</>}

	{type === 'footer' && <>
		<BorderElement borderPosition='top' shapeElement={FooterTop}/>
	</>}
	{children}
</RootContainer>

WavyBackground.propTypes = {
	className: PropTypes.string,
	type: PropTypes.oneOf(['darkBlue', 'gray', 'footer']).isRequired,
	underColor: PropTypes.string,
	children: PropTypes.node.isRequired,
}

WavyBackground.defaultProps = {
	className: '',
	underColor: 'white',
}

export default WavyBackground
